import React, { useContext } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./View_address_modal.css";
import { Context } from "../../../../utils/context";

const View_address_modal_Images = (props) => {
  const { IMG_URL } = useContext(Context);
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_address_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Payment Proof
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="addp">
            <div className="row">
              <div className="col-4">
                <span>Payment Proof:</span>
              </div>
              <div className="col-8">
                {props?.data?.orders_details?.[0]?.payment_proof && (
                  <div className="img_holder">
                    <img
                      src={`${IMG_URL}${props?.data?.orders_details?.[0]?.payment_proof}`}
                      alt="Image"
                      className="payment_preview_img"
                    />
                  </div>
                )}
              </div>
            </div>
          </p>
          <hr />
          <p className="addp">
            <div className="row">
              <div className="col-4">
                <span>Other Image:</span>
              </div>
              <div className="col-8">
                {props?.data?.orders_details?.[0]?.other_image && (
                  <div className="img_holder">
                    <img
                      src={`${IMG_URL}${props?.data?.orders_details?.[0]?.other_image}`}
                      alt="Image"
                      className="payment_preview_img"
                    />
                  </div>
                )}
              </div>
            </div>
          </p>

          <p className="addp">
            <span>Delivery Boy Remark:</span>
            {props?.data?.orders_details?.[0]?.remark || ""}
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default View_address_modal_Images;
